<template>
    <div class="messageContent">
        <div class="messages flx alc jsb">
            <div class="mitenm" v-for="item,index in list">
                <div class="miname single" v-text="item.title"></div>
                <div class="midate" v-text="item.createtime_text"></div>
                <div class="messageDedtail flx alc jsb">
                    <div class="messageintro multy2" v-text="item.intro"></div>
                    <div class="messageAvatar" v-if="item.avatar">
                        <img :src="$img(item.avatar)" alt="" />
                    </div>
                </div>
                <div class="checkDetail flx alc jsb" @click="checkdetail(item)">
                    <div class="cdleft">
                        查看详情
                    </div>
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="dialogVisible" width="720px" :show-close="true" title=""
            custom-class="msg-dialog">
            
            <div class="mtitle" v-text="title">
                
            </div>
            <div class="mdates" v-text="dates">
                
            </div>
            <div class="gaps"></div>
            <div class="msg-content-wrap">
                <div v-html="content">

                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {
        getMessagelistItem,
        getMessageDetail
    } from "@/api/index.js"
    export default {
        name: 'Order',
        data() {
            return {
                cur: "1",
                list: [],
                page: 1,
                dialogVisible: false,
                content: "",
                title:"",
                dates:""
            }
        },
        mounted() {
            this.getList()
        },
        methods: {
            checkdetail(e) {
                let that = this
               
                getMessageDetail(e.id).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.content = res.data.content
                        that.title = res.data.title
                        that.dates = res.data.createtime
                        that.dialogVisible = true
                        
                    }
                })
            },
            getList() {
                let that = this
                let data = {}
                data.page = that.page
                data.source = 1
                getMessagelistItem(data).then((res) => {
                    console.log("message", res)
                    if (res.code == 1) {
                        that.list = res.data.data
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .gaps{
        width: 100%;
        margin: 14px 0;
        height: 2px;
        background: #ececec;
    }
    .mtitle{
        font-weight: 600;
        font-size: 20px;
        color: #333333;
        margin-bottom: 10px;
    }
    .msg-dialog>>>.el-dialog__header {
        display: none !important;
    }

    /* 深度修改dialog外层样式 */
    .msg-dialog>>>.el-dialog__body {
        padding: 0 !important;
    }

    .msg-dialog-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0 10px;
    }

    .dialog-title {
        font-size: 18px;
        font-weight: bold;
    }

    .close-icon {
        font-size: 22px;
        cursor: pointer;
        color: #666;
    }

    .close-icon:hover {
        color: #333;
    }
    .msg-content-wrap {
        padding: 0 !important;
    }

    .msg-card {
        background: #ffffff;
        border-radius: 12px;
        padding: 24px;
    }

    .msg-title {
        font-size: 22px;
        color: #333;
        margin: 0 0 8px;
        font-weight: bold;
    }

    .msg-date {
        font-size: 14px;
        color: #999;
        margin-bottom: 12px;
    }

    .divider {
        height: 1px;
        background: #e5e7eb;
        margin-bottom: 16px;
    }

    .msg-text {
        font-size: 15px;
        color: #606266;
        line-height: 1.7;
        word-break: break‑all;
    }

    .msg-image-box {
        margin-top: 20px;
        width: 100%;
        height: 180px;
        background: #e8e8e8;
        border‑radius: 10px;
        /* 如果放图片，开启下面 */
        /* position:relative; */
    }

    /* 如果里面放img，取消注释 */
    /*
    .msg-image-box img {
      width:100%;
      height:100%;
      object-fit:cover;
      border‑radius:10px;
    }
    */
    .cdleft {
        font-size: 12px;
        color: #333333;
    }

    .checkDetail {
        box-sizing: border-box;
        padding: 16px 0 0 0;
        border-top: 1px solid #f4f4f4;
        margin-top: 25px;
        cursor: pointer;
    }

    .messageAvatar {
        width: 50px;
        height: 50px;
        flex-shrink: 0;
        margin-left: 84px;
    }

    .messageAvatar img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }

    .messageintro {
        font-size: 14px;
        color: #666666;
        line-height: 21px;
    }

    .midate {
        font-size: 13px;
        color: #999999;
        line-height: 21px;
        margin: 6px 0;
    }

    .miname {
        font-weight: 600;
        font-size: 16px;
        color: #333333;
    }

    .messageContent {
        box-sizing: border-box;
        padding: 30px;
        text-align: left;
    }

    .mitenm {
        width: 448px;
        border-radius: 5px;
        border: 1px solid #E8E8E8;
        box-sizing: border-box;
        padding: 20px;

    }
</style>